import styled from '@emotion/styled';
import _ from 'lodash';

import Picture from './oc-picture';
import Heading from './PageBuilder/Heading';
import RichText from './PageBuilder/RichText';
// eslint-disable-next-line camelcase
import placeholder_url from '../../placeholder';

const heights = {
  tall: 680,
  medium: 464,
  short: 240,
};

const HeroImage = styled(Picture)`
  display: inline-block;
  margin-bottom: 32px;
  max-height: ${heights.short}px;
  object-fit: cover;
  object-position: center;
  width: 100%;

  @media (min-width: 768px) {
    max-height: ${props => heights[props.$height]}px;
  }
`;

const HeroTextContainer = styled.div`
  padding: 0 15px;

  @media (min-width: 1200px) {
    padding: 0 85px;
  }
`;

const HeroType6 = ({ copy, image, height = 'short' }) => {
  const imageUrl = image && Picture.DefaultOrCrop(image.file, image.crop, placeholder_url(1360, heights[height]));
  return <>
    <HeroImage source={imageUrl} $height={height} alt={image?.alt} />
    <HeroTextContainer>
      <Heading mainHeading={copy?.mainHeading} />
      <RichText content={copy?.body} />
    </HeroTextContainer>
  </>
};

export default HeroType6;
